import { Hint } from '../../shared/ui/hint';
import type { TDiffLine, TVersionDiff } from '../../entities/transform';

// The only place red and green mean added/removed rather than delivery; no caller may borrow these classes.
const SIGN: Record<TDiffLine['type'], string> = { same: ' ', added: '+', removed: '−' };

const FILL: Record<TDiffLine['type'], string> = {
  same: '',
  added: 'bg-added-surface',
  removed: 'bg-removed-surface',
};

const GUTTER: Record<TDiffLine['type'], string> = {
  same: 'text-suppressed',
  added: 'text-success',
  removed: 'text-danger',
};

export const VersionDiff = ({ diff, what }: { diff: TVersionDiff; what: string }) => {
  if (diff.lines.length === 0) {
    return <Hint>These two versions hold identical {what}, character for character</Hint>;
  }

  return (
    <div>
      <div className="max-h-facets overflow-auto rounded-panel bg-surface-sunken py-3">
        {diff.lines.map((line, index) => (
          <div key={index} className={`flex font-mono text-meta leading-20 ${FILL[line.type]}`}>
            <span className={`w-10 shrink-0 pr-3 text-right ${GUTTER[line.type]}`}>
              {SIGN[line.type]}
            </span>
            <span className="whitespace-pre text-primary">{line.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
